var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertsSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-592.849 -354.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5951.866,196.877h-4.39a.881.881,0,0,1-.769-.392.92.92,0,0,1-.021-.9l2.19-4.562v-5.462a6.072,6.072,0,0,1,6.064-6.064,6.072,6.072,0,0,1,6.067,6.064v5.463l2.187,4.56a.916.916,0,0,1-.019.9.879.879,0,0,1-.769.392h-4.39a3.12,3.12,0,0,1-3.077,2.624A3.119,3.119,0,0,1-5951.866,196.877Zm3.075,1.64a2.138,2.138,0,0,0,2.075-1.64h-4.147A2.135,2.135,0,0,0-5948.791,198.517Z",
    transform: "translate(6551.649 175)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsSelected);
export default __webpack_public_path__ + "static/media/AlertsSelected.9617dd4d7268606a0bfbd33bc4d53051.svg";
export { ForwardRef as ReactComponent };